export const DESIGNER_FEATURE_GROUP_ID = "DESIGNER_FEATURE_GROUP";
